import { FC, memo } from 'react'
import { Flex, SimpleGrid, Text } from '@chakra-ui/react'

import CalendarNumber from './components/CalendarNumber'

import StartCalendarHeader from './components/Header'
import { useCalendarFilters } from '../../../../contexts/CalendarFiltersManager/Provider'
import CalendarCard from '../../../../localComponents/CalendarCard'

type Props = {
  year: number
  daysInCalendar: any[]
  daysOfTheWeek: string[]
  stringMonth: string
  goPreviousMonth: () => void
}

const StartCalendar: FC<Props> = ({ year, daysOfTheWeek, stringMonth, goPreviousMonth, daysInCalendar }) => {
  const { startDate, setStartDate, finalDate, setFinalDate } = useCalendarFilters()

  return (
    <CalendarCard borderRight="1px" borderColor="borderColor">
      <StartCalendarHeader year={year} stringMonth={stringMonth} onClick={goPreviousMonth} />

      <SimpleGrid columns={7} gap={2}>
        {daysOfTheWeek.map((week, index) => (
          <Flex justify={{ base: 'flex-start', md: 'center' }} pt={4} key={index}>
            <Text fontSize="xs">{week}</Text>
          </Flex>
        ))}

        {daysInCalendar.map((dayInfo) => {
          return (
            <CalendarNumber
              {...dayInfo}
              key={dayInfo.stringDate}
              startDate={startDate}
              setStartDate={setStartDate}
              finalDate={finalDate}
              setFinalDate={setFinalDate}
            />
          )
        })}
      </SimpleGrid>
    </CalendarCard>
  )
}

export default memo(StartCalendar)
